import  Notifications  from './main';
import { reducer, moduleName, getNotificationsList } from './ducks';

export { Notifications, getNotificationsList, reducer, moduleName }


// WEBPACK FOOTER //
// /var/www/build-health-2/src/modules/Notifications/index.js